import { useTheme } from "@amx/ux-twoui-theming";
import { HighContrastSelector, ILinkStyles, Link as FluentLink } from "@fluentui/react";
import React from "react";
import { useComponentLogger } from "../../../shared/logging";
import { validateProps } from "../../../shared/props";
import { getFontRampStyle } from "../../../styles/fonts";
import { TruncatedText } from "../../TruncatedText/TruncatedText";
import { BaseLinkProps } from "../shared/props";

export interface NoHrefLinkProps extends BaseLinkProps {
    /** callback for when the NoHrefLink is clicked */
    readonly onClick: (event: React.MouseEvent<HTMLElement>) => void;
}

export const NoHrefLink: React.FC<NoHrefLinkProps> = ({
    children,
    disabled,
    textVariant = "bodyThemeText",
    truncatedLinkProps,
    underline,
    ...otherProps
}) => {
    useComponentLogger("NoHrefLink", otherProps.id);

    validateProps("NoHrefLink", otherProps);
    const theme = useTheme();

    const fontRampStyles = getFontRampStyle(theme, textVariant, undefined, disabled ? "disabled" : undefined);
    const defaultLinkStyles: ILinkStyles = {
        root: {
            fontSize: fontRampStyles.fontSize,
            fontWeight: fontRampStyles.fontWeight,
            lineHeight: fontRampStyles.lineHeight,
            fontFamily: fontRampStyles.fontFamily,
            selectors : fontRampStyles.selectors,
            color: fontRampStyles.color,
            ":hover": {
                color: fontRampStyles.hoverColor
            },
        }
    };

    if (!disabled) {
        defaultLinkStyles.root!["selectors"] = {
            [HighContrastSelector]: {
                color: "linktext"
            },
            // Override the color, set above, in -ms-high-contrast media query to support NoHrefLink in IE and MS Edge Legacy browsers.
            "@media screen and (-ms-high-contrast: active)": {
                color: "-ms-hotlight"
            }
        };
    }
    return (
        <FluentLink
            disabled={disabled}
            styles={defaultLinkStyles}
            underline={underline}
            {...otherProps}
        >
            {truncatedLinkProps ? (
                <TruncatedText
                    lines={truncatedLinkProps.lines}
                    variant={textVariant}
                    stopPropagation={false}
                >
                    {children}
                </TruncatedText>
            ) :
                children
            }
        </FluentLink>
    );
};
